import PropTypes from 'prop-types';
import React from 'react';

export const GESTURES = {
  swipeUp: 'swipeUp',
  swipeDown: 'swipeDown',
  swipeLeft: 'swipeLeft',
  swipeRight: 'swipeRight',
  tap: 'tap',
};

function preventDefault(e) {
  e.preventDefault();
}

/**
 * @deprecated Please use the useSwipe hook from @ezugi/hooks instead
 * <Gesture /> provides a way to detect swiping gestures and calls back a component to update
 * on the required gesture emitted
 */
class Gesture extends React.PureComponent {

  touchStartX = 0;

  touchStartY = 0;

  touchEndX = 0;

  touchEndY = 0;

  componentDidMount() {
    const { element, preventTouchMove } = this.props;
    element.addEventListener('touchstart', this.handleTouchStart);
    element.addEventListener('touchend', this.handleTouchEnd);

    if (preventTouchMove) {
      element.addEventListener('touchmove', preventDefault, { passive: false });
    }
  }

  componentWillUnmount() {
    const { element, preventTouchMove } = this.props;
    element.removeEventListener('touchstart', this.handleTouchStart);
    element.removeEventListener('touchend', this.handleTouchEnd);

    if (preventTouchMove) {
      element.removeEventListener('touchmove', preventDefault);
    }
  }

  handleTouchEnd = (event) => {
    this.touchEndX = event.changedTouches[0].screenX;
    this.touchEndY = event.changedTouches[0].screenY;

    const absX = Math.abs(this.touchEndX - this.touchStartX);
    const absY = Math.abs(this.touchEndY - this.touchStartY);

    const possibleGestures = {
      swipeLeft: this.touchEndX < this.touchStartX && absX,
      swipeRight: this.touchEndX > this.touchStartX && absX,
      swipeUp: this.touchEndY < this.touchStartY && absY,
      swipeDown: this.touchEndY > this.touchStartY && absY,
      tap: this.touchEndY === this.touchStartY && this.touchEndX === this.touchStartY,
    };

    const { gesture, onGesture } = this.props;

    const currentGesture = Object
      .keys(possibleGestures)
      .reduce((a, b) => (possibleGestures[a] > possibleGestures[b] ? a : b));

    if (gesture === currentGesture || gesture === 'any') {
      onGesture(event, currentGesture);
    }
  };

  /**
     * Handle logic for determining which gesture the user is doing
     * And call the onGesture callback
     * @param event
     */
  handleTouchStart = (event) => {
    event.stopPropagation();
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  };

  render() {
    return this.props.children || null;
  }

}

Gesture.propTypes = {
  // Element to watch gestures on
  element: PropTypes.oneOfType([ PropTypes.instanceOf(Element), PropTypes.instanceOf(Document) ]),
  // Used to callback only for the gesture we want
  gesture: PropTypes.oneOf([ ...Object.values(GESTURES), 'any' ]),
  // Callback after performing a gesture
  onGesture: PropTypes.func.isRequired,
  // Needed if we want to have user interaction with these swipe gestures
  preventTouchMove: PropTypes.bool,
};

Gesture.defaultProps = {
  // Default to the document
  element: document,
  // Default to calling the callback on any gesture
  gesture: 'any',
  // Default to false in order to allow scrolling
  preventTouchMove: false,
};

export default Gesture;
